document.addEventListener("DOMContentLoaded", () => {
  const initSwiper = (selector, config) => {
    const elements = document.querySelectorAll(`.${selector}`);
    if (!elements.length) return; // Exit if no elements found

    elements.forEach((element) => {
      const sectionId = element.dataset.sectionId;
      if (!sectionId) return;

      const slidesPerView = parseInt(element.dataset.desktopSlidesPerView, 10) || config.desktopSlidesPerView;

      // Clone and update config for each instance
      const swiperConfig = Object.assign({}, config, {
        pagination: config.pagination
          ? Object.assign({}, config.pagination, {
              el: `.swiper-pagination-${sectionId}`,
            })
          : false,
        navigation: config.navigation
          ? {
              nextEl: `.swiper-button-next-${sectionId}`,
              prevEl: `.swiper-button-prev-${sectionId}`,
            }
          : false,
      });

      try {
        new Swiper(`.${selector}-${sectionId}`, swiperConfig);
      } catch (error) {
        console.error(`Failed to initialize Swiper for ${selector}-${sectionId}:`, error);
      }
    });
  };

  const reviewsSliderEl = document.querySelector(".reviewsSlider");
  if(reviewsSliderEl) {
    // Initialize Review Slider (if exists)
    const slidesPerView1200 = parseInt(reviewsSliderEl.dataset.desktopSlidesPerView, 10) || 3; 
    initSwiper("reviewsSlider", {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        1200: { slidesPerView: slidesPerView1200, spaceBetween: 30, pagination: false, loop: false },
        800: { slidesPerView: 2, spaceBetween: 30, pagination: false, loop: false },
      },
      pagination: { clickable: true },
      navigation: {},
    });
  }

    // Initialize Product Media Slider (if exists)
    initSwiper("productMainMediaSlider", {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: { clickable: true },
      navigation: false,
    });


    // Clinical Slider
    const breakpoint = window.matchMedia('(min-width: 750px)');
    let clinicalSwipers = [];

    const breakpointChecker = function() {
      const clinicalElements = document.querySelectorAll('.clinicalSlider');
      if (!clinicalElements.length) return;

      clinicalElements.forEach((element) => {
        const sectionId = element.dataset.sectionId;
        if (!sectionId) return;

        // Check if the breakpoint is matched and handle initialization/destroy logic
        if (breakpoint.matches) {
          // Destroy the swiper instance if it's larger than breakpoint
          const swiperInstance = clinicalSwipers.find((swiper) => swiper.sectionId === sectionId);
          if (swiperInstance) {
            swiperInstance.instance.destroy(true, true);
            clinicalSwipers = clinicalSwipers.filter((swiper) => swiper.sectionId !== sectionId);
          }
        } else {
          // If smaller viewport, initialize swiper
          const swiperInstance = clinicalSwipers.find((swiper) => swiper.sectionId === sectionId);
          if (!swiperInstance) {
            enableClinicalSwiper(sectionId);
          }
        }
      });
    };
      
    const enableClinicalSwiper = function(sectionId) {
      const swiperInstance = new Swiper(`.clinicalSlider-${sectionId}`, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: `.swiper-pagination-${sectionId}`,
          clickable: true
        },
        navigation: {
          nextEl: `.swiper-button-next-${sectionId}`,
          prevEl: `.swiper-button-prev-${sectionId}`,
        },
      });

      clinicalSwipers.push({ sectionId, instance: swiperInstance });
    };

    // Listen to changes in viewport size
    breakpoint.addEventListener('change', breakpointChecker);
    breakpointChecker(); // Initial check to load sliders correctly based on viewport
});
